import React from "react";
import "../css/PrivacyPolicy.css";

const PrivacyPolicyScreen = ({ stateCode }) => {
  return (
    <div
      className="privacy-container"
      style={{
        display: stateCode.code === 999 ? "block" : "none",
      }}
    >
      <div style={styles.container}>
        <h1 style={styles.title}>개인정보처리방침</h1>
        <p style={styles.content}>
          team purple은 정보통신서비스제공자가 준수하여야 하는 대한민국의 관계
          법령 및 개인정보보호 규정을 준수하며, 관련 법령에 의거한
          개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.
        </p>
        <p style={styles.content}>
          momo 서비스의 개인정보처리방침은 다음과 같습니다.
        </p>
        <h1 style={styles.title}>1. 개인정보의 수집 목적</h1>
        <p style={styles.content}>회원가입, 서비스제공</p>
        <h3 style={styles.title}>2. 개인정보의 수집 및 보유 기간</h3>
        <p style={styles.content}>
          team purple는 원칙적으로 이용자의 개인정보를 회원탈퇴 시까지
          보유합니다.
        </p>
        <h3 style={styles.title}>3. 수집하는 개인정보의 항목</h3>
        <p style={styles.content}>
          가.서비스 가입 과정에서 아래와 같은 정보를 이용자로부터 수집합니다.
        </p>
        <p style={styles.content}>
          -구글 계정 이용시 : 이메일, 사용자명, UID
          <br />
          -애플 계정 이용시 : 이메일, 사용자명, UID
        </p>
        <p style={styles.content}>
          나.사용자가 서비스의 특정 기능을 사용하거나 자신의 정보를 등록하는
          경우 (이름, 연락처, 이메일, 사진 등)을 수집합니다.
        </p>
        <p style={styles.content}>다.사용자의 당사 서비스 이용에 관한 정보</p>
        <p style={styles.content}>
          team purple은 사용자가 당사 서비스를 어떻게 이용하는지에 대한 정보를
          자동으로 얻습니다. 여기에는 디바이스 고유ID, 쿠키, 광고 식별자,
          사용자가 당사 서비스에서 방문하는 페이지, 해당 페이지에서 보낸 시간,
          사용자가 클릭하는 당사 서비스의 링크(광고 포함) 및 기타 통계 데이터가
          포함 됩니다.
        </p>
        <h2 style={styles.title}>3. 개인정보의 파기절차 및 방법</h2>
        <p style={styles.content}>
          클라우드에 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을
          사용하여 삭제합니다.
        </p>
        <h2 style={styles.title}>4. 개인정보의 안정성 확보조치에 관한 사항</h2>
        <p style={styles.content}>
          구글의 파이어베이스 클라우드를 사용해 데이터를 관리 보안합니다.
          <br />
          <br />
          team purple은 사용자의 개인 정보에 대한 무단 액세스, 분실, 훼손, 변조
          또는 유출을 방지하기 위해 필요한 조치를 취합니다.. 또한 당사는
          사용자가 입력한 정보(텍스트, 숫자, 첨부 이미지)를 당사 서버나 외부
          서비스로 전송하거나 저장하지 않습니다.
          <br />
          <br />
          team purple은 수집하는 개인 정보는 사용되는 화면과 해당 사용 시간 및
          광고 식별자 등 행동 분석 데이터입니다. 당사의 보안 시스템은 사용자가
          입력한 데이터가 저장되지 않도록 보장합니다.
        </p>
        <h2 style={styles.title}>5. 개인정보 보호책임자</h2>
        <p style={styles.content}>
          소속 : team purple
          <br />
          이름 : 유민혁
          <br />
          이메일 : teampurple629@gmail.com
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: { padding: "20px 30px" },
  title: { fontSize: "1.3em", marginTop: "10px" },
  content: { fontSize: "1em", marginTop: "10px", paddingLeft: "5px" },
};

export default PrivacyPolicyScreen;
